const routes = {
  home: '/',
  transfer: '/transfer',
  burn: '/burn',
  mine: '/mine'
}

export default routes